import { useState, useCallback } from 'react';

export function useApi() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = useCallback(async (apiCall, options = {}) => {
    const { showError = true, onSuccess, onError } = options;
    
    try {
      setLoading(true);
      setError(null);
      
      const result = await apiCall();
      
      if (onSuccess) {
        onSuccess(result.data);
      }
      
      return { success: true, data: result.data };
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred';
      
      if (showError) {
        setError(errorMessage);
      }
      
      if (onError) {
        onError(err);
      }
      
      // errorCode lets callers show their own (translated) message per error
      return { success: false, error: errorMessage, errorCode: err.response?.data?.error_code };
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    loading,
    error,
    execute,
    clearError,
  };
}